<template>
  <LayoutChallenge
    :lessonName="lesson.name"
    :stepCount="this.steps.length"
    :currentStep="step"
    v-on:backClick="handleClickBack"
    v-on:closeClick="handleClickClose"
    v-on:nextClick="handleClickNextStep"
    @answerQuiz="handleAnswerQuiz"
  >
    <div class="flex flex-col">
      <h1 class="mx-2 mt-0 text-center text-lg">{{ this.lesson.name }}</h1>
      <span class=" text-center text-white text-xs px-2 py-1 mb-3 mt-1">
        <span
          v-if="discipline"
          class="px-2 py-1 rounded-full"
          :style="{ backgroundColor: discipline.hex_color }"
        >
          {{ discipline.name }}</span
        >
      </span>

      <div class="mb-5">
        <div class="flex-1">
          <LessonText
            class=""
            v-if="currentContent && currentContent.type === 'text'"
            :text="currentContent.text_body"
            :title="currentContent.name"
          ></LessonText>
          <quiz
            v-if="currentContent && currentContent.type === 'quiz'"
            class="quiz mx-2"
            :current-content="currentContent"
            @answerQuiz="handleCompletedQuiz"
            @clickedPlaceholder="handleClickQuiz"
            @clickedAlternative="handleClickQuiz"
            @clickedTryAgain="handleClickQuiz"
            ref="quiz"
          />
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <QuizAnswerButton
        :visible="currentContent && currentContent.type === 'quiz'"
        :disabled="!answerQuizEnabled"
        @clickedButton="handleAnswerQuiz"
      />
      <button @click="handleClickNextStep" class="button button-primary mt-4">
        Próxima
      </button>
    </template>
  </LayoutChallenge>
</template>

<script>
import LayoutChallenge from "../layouts/LayoutChallenge.vue";
import Quiz from "../components/Quiz.vue";
// import axios from "../axiosClient";
import LessonText from "../components/LessonText";
import QuizAnswerButton from "../components/QuizAnswerButton";

export default {
  name: "Lesson",
  data() {
    return {
      step: 1,
      steps: [],
      challengeIdFromRoute: "",
      challenge: {},
      lesson: "",
      lessonNumber: "",
      urlPath: "/desafio",
      actionName: "fetchLastChallenge",
      answerQuizEnabled: false
    };
  },
  components: {
    LayoutChallenge,
    quiz: Quiz,
    LessonText,
    QuizAnswerButton
  },

  computed: {
    currentContent: function() {
      return this.steps.find(content => {
        return content.step == this.step;
      });
    },
    discipline: function() {
      if (this.lesson.discipline) {
        return this.lesson.discipline;
      }
      return null;
    }
  },
  methods: {
    handleAnswerQuiz() {
      this.$refs.quiz.answerQuiz();
      this.answerQuizEnabled = false; // para desabilitar
    },
    handleClickQuiz(spots) {
      this.answerQuizEnabled = !spots.some(spot => spot === "???");
    },

    handleClickNextStep() {
      this.step = this.step + 1;

      //Vamos marcar como concluído o content anterior, se não há quiz. Porque se há, quem vai marcar é o componente quiz.
      // this.setPreviousStepContentCompleteIfThereIsNoQuiz();

      //acabou a lesson. Se ele completou, vamos mandar para a completed. Se não, vamos mandar pro desafio.
      if (this.step > this.steps.length) {
        // this.handleClickLastStep();
        this.step = 1;
      }
    },

    handleClickBack() {
      (this.stepBack = true), (this.step = this.step - 1);
      this.stepBack = false;

      if (this.step < 1) {
        this.step = 1;
      }
    },
    handleClickClose() {
      // this.$router.push(this.urlPath);
    },
    handleCompletedQuiz(payload) {
      return payload;
    },

    mountSteps() {
      const contentArray = [];
      let stepCounter = 1;

      // vamos criar o array de Steps, marcando
      this.lesson.contents.forEach(content => {
        if (content.text_body) {
          contentArray.push({
            contentId: content.id,
            name: content.name,
            type: "text",
            step: stepCounter,
            text_body: content.text_body,
            completed: content.completed_at ? true : false
          });
          stepCounter++;
        }
        if (content.quiz_question) {
          contentArray.push({
            contentId: content.id,
            name: content.name,
            type: "quiz",
            step: stepCounter,
            quiz_question: content.quiz_question,
            quiz_alternatives: content.quiz_alternatives,
            completed: content.completed_at ? true : false,
            answered_alternatives: content.completed_at
              ? content.answered_alternatives
              : false
          });
          stepCounter++;
        }
      });

      this.steps = contentArray;
    }
  },

  created() {
    this.$http
      .get(`/lessons/${this.$route.params.lessonId}`)
      .then(({ data }) => {
        this.lesson = data.data;
        this.mountSteps();
      });
  }
};
</script>
